import { jsx as _jsx } from "react/jsx-runtime";
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { BasicViewContainer } from './BasicViewContainer';
import { FramedViewContainer } from './FramedViewContainer';
export const ViewContainer = () => {
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const Container = isInstanceOfSignupEmbedder ? FramedViewContainer : BasicViewContainer;
  return /*#__PURE__*/_jsx(Container, {});
};